import axiosInstance from "../api";
import type {
  PatientInfoCheckData,
  PatientInfoCheckResponse,
} from "../models/API/responseModels/patientInfoCheckResponse.model";

const PATIENT_INFO_CHECK_PATH = "v1/orders/new-flow/classify-analyze-document-patient-info-check";

/**
 * GET patient-info completeness for an uploaded document (Azure key / filepath).
 */
export async function fetchPatientInfoCheck(
  filepath: string,
  token: string
): Promise<PatientInfoCheckData | undefined> {
  const qs = new URLSearchParams({ key: filepath });
  const res = await axiosInstance.get<PatientInfoCheckResponse>(
    `${PATIENT_INFO_CHECK_PATH}?${qs.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const body = res.data;
  if (!body?.success) {
    throw new Error(body?.message ?? "Patient information check failed.");
  }
  return body.data;
}
